export const isKiaOfStamford = () => location.host.endsWith('stamfordkia.com')
